import axios from 'axios';


/**
 * Class representing application device utilities and configurations.
 * This class handles device-specific settings, server configurations, and utility methods.
 */
class AppDevice {
    /** @type {string} The base URL for the DICOM server */
    static ServerUrl = '';
    /** @type {string} The URL for external services */
    static ExternalServer = '';
    /** @type {string} The name of the institution using the application */
    static InstitutionName = '';
    /** @type {number} Time duration for sharing functionality */
    static sharetime = 0;
    /** @type {string} Reference phone number */
    static phoneRef = '';
    /** @type {string} Default country code for phone numbers */
    static DefaultCountry = "";
    /** @type {string} Words per minute configuration */
    static WPM = "";
    /** 
     * @type {Object} Company information
     * @property {string} name - Company name
     * @property {string} address - Company address
     * @property {string} phone - Company phone number
     * @property {string} website - Company website URL
     */
    static CompanyInfo = {
        name:"",
        address:"",
        phone:"",
        website:""
    };
    /** @type {Array<Object>} List of country codes with their details */
    static countryCodes = [];
    /** 
     * @type {Object} Application settings
     * @property {string} NameComplement - Name complement configuration
     */
    static AppSetings = {
        NameComplement:"age"
    };
    /**
     * Initializes the device configuration by loading required resources
     * @async
     * @returns {Promise<void>}
     * @throws {Error} If any of the required resources fail to load
     */
    static async DeviceInit(){
        const P = []
        P.push(axios.get('/configuracion.json'))
        P.push(axios.get('/wp.txt'))
        P.push(axios.get('/countrycodes.json'))
        P.push(axios.get('/appsettings.json'))
        const [config, wpm, countryCodes, appsettings] = await Promise.all(P)
        this.WPM = wpm.data;
        this.ServerUrl = config.data.ServidorDicom;
        this.ExternalServer = config.data.ServicorExterno;
        this.InstitutionName = config.data.NombreInstitucion;
        this.sharetime = config.data.sharetime;
        this.phoneRef = config.data.ref;
        this.DefaultCountry = config.data.countryCode?config.data.countryCode:"591";
        this.CompanyInfo = {
            name:config.data.CompanyInfo.name,
            address:config.data.CompanyInfo.address,
            phone:config.data.CompanyInfo.phone,
            website:config.data.CompanyInfo.website
        };
        this.countryCodes = countryCodes.data;
        this.AppSetings = appsettings.data;
    };
    /**
     * Converts the current device configuration to a JSON object
     * @returns {Object} Current device configuration
     */
    static toJson(){
        return {
            ServidorDicom:this.ServerUrl,
            NombreInstitucion:this.InstitutionName,
            ServicorExterno:this.ExternalServer,
            sharetime:this.sharetime,
            ref:this.phoneRef,
            countryCode:this.DefaultCountry,
            CompanyInfo:this.CompanyInfo,
            WPM:this.WPM,
            AppSetings:this.AppSetings,
            countryCodes:this.countryCodes
        }
    };
    /**
     * Checks if the current device is a mobile device
     * @returns {boolean} True if the device is a mobile device, false otherwise
     */
    static isMobile() {
        return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    };
}

export default AppDevice;